import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content z-index-1 text-center text-white mx-10" }
const _hoisted_2 = { class: "fs-2x mb-8" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "sub-header h-450px d-flex justify-content-center shadow",
    style: _normalizeStyle(_ctx.bgStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", {
        class: "fs-5 fw-light",
        innerHTML: _ctx.subTitle
      }, null, 8, _hoisted_3)
    ])
  ], 4))
}